import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Intro',
		component: () => import('../views/Intro.vue')
	},
	{
		path: '/gioca',
		name: 'Game',
		component: () => import('../views/Game.vue')
	},
	{
		path: '/prepara',
		name: 'Prepare',
		component: () => import('../views/Prepare.vue')
	},	
	{
		path: '/procedi',
		name: 'Proceed',
		component: () => import('../views/Proceed.vue')
	},
	{
		path: '/stampa',
		name: 'Print',
		component: () => import('../views/Print.vue')
	}
]

const router = new VueRouter({
	routes
})

export default router
